<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="usercenter">
    <!-- 顶部：标题 + 退出登录 -->
    <div class="uc-header">
      <h1 class="uc-title">用户中心</h1>
      <el-button class="uc-plain-btn" @click="handleLogout">退出登录</el-button>
    </div>

    <!-- Tab：导入导出暂为禁用状态 -->
    <el-tabs v-model="activeTab" class="uc-tabs">
      <el-tab-pane label="设置" name="setting">
        <!-- 账号信息 -->
        <div class="uc-section">
          <div class="uc-section-title">账号信息</div>
          <div class="uc-account">
            <div class="uc-avatar">{{ avatarText }}</div>
            <div class="uc-account-info">
              <div class="uc-nickname">{{ userInfo.username || "未设置" }}</div>
              <div class="uc-email">{{ userInfo.email || "-" }}</div>
            </div>
          </div>
        </div>

        <!-- 账号设置 -->
        <div class="uc-section">
          <div class="uc-section-title">账号设置</div>

          <div class="uc-row">
            <div class="uc-row-label">昵称</div>
            <div class="uc-row-value">{{ userInfo.username || "未设置" }}</div>
            <div class="uc-row-action">
              <el-button class="uc-plain-btn" @click="openNicknameDialog">
                修改昵称
              </el-button>
            </div>
          </div>

          <div class="uc-row">
            <div class="uc-row-label">邮箱</div>
            <div class="uc-row-value">{{ userInfo.email || "-" }}</div>
            <div class="uc-row-action">
              <!-- 功能暂未开放：按钮禁用，外层 span 用于让 tooltip 能捕获鼠标事件 -->
              <el-tooltip content="功能开发中" placement="top">
                <span class="uc-disabled-wrap">
                  <el-button class="uc-plain-btn" disabled>更换邮箱</el-button>
                </span>
              </el-tooltip>
            </div>
          </div>

          <div class="uc-row">
            <div class="uc-row-label">密码</div>
            <div class="uc-row-value">••••••••</div>
            <div class="uc-row-action">
              <el-button class="uc-plain-btn" @click="openPasswordDialog">
                修改密码
              </el-button>
            </div>
          </div>

          <div class="uc-row uc-row--last">
            <div class="uc-row-label">注册时间</div>
            <div class="uc-row-value">{{ formattedCreateTime }}</div>
          </div>
        </div>

        <!-- 偏好设置 -->
        <div class="uc-section">
          <div class="uc-section-title">偏好设置</div>

          <div class="uc-pref-row">
            <div class="uc-pref-label">显示已访问过的村</div>
            <el-switch
              :value="showRecentVisitValue"
              active-color="#ff4d90"
              inactive-color="#dcdfe6"
              @change="onShowRecentChange"
            />
          </div>

          <div class="uc-pref-row">
            <div class="uc-pref-label">接收村友动态通知</div>
            <el-tooltip content="功能开发中" placement="top">
              <span class="uc-disabled-wrap">
                <el-switch :value="false" disabled inactive-color="#dcdfe6" />
              </span>
            </el-tooltip>
          </div>
        </div>

        <!-- 注销账号 -->
        <div class="uc-section">
          <div class="uc-section-title">注销账号</div>
          <div class="uc-danger">
            <div class="uc-danger-text">
              注销后账号内的站村数据将无法恢复，请谨慎操作。
            </div>
            <el-tooltip content="功能开发中" placement="top">
              <span class="uc-disabled-wrap">
                <el-button class="uc-plain-btn" disabled>注销账号</el-button>
              </span>
            </el-tooltip>
          </div>
        </div>
      </el-tab-pane>

      <!-- 导入导出：暂为禁用状态 -->
      <el-tab-pane label="导入导出" name="transfer" disabled></el-tab-pane>
    </el-tabs>

    <!-- 修改昵称：样式与退出登录确认弹窗（Element MessageBox）保持一致 -->
    <el-dialog
      title="修改昵称"
      :visible.sync="nicknameDialogVisible"
      width="420px"
      top="0"
      custom-class="uc-msgbox"
    >
      <el-form
        ref="nicknameForm"
        :model="nicknameForm"
        :rules="nicknameRules"
        label-width="0"
        hide-required-asterisk
        class="uc-msgbox-form"
      >
        <el-form-item prop="username">
          <el-input
            v-model="nicknameForm.username"
            maxlength="8"
            placeholder="请输入昵称（1-8 个字符）"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="nicknameDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="saveNickname">
          保存
        </el-button>
      </div>
    </el-dialog>

    <!-- 修改密码：样式与退出登录确认弹窗（Element MessageBox）保持一致 -->
    <el-dialog
      title="修改密码"
      :visible.sync="passwordDialogVisible"
      width="420px"
      top="0"
      custom-class="uc-msgbox"
    >
      <el-form
        ref="passwordForm"
        :model="passwordForm"
        :rules="passwordRules"
        label-width="0"
        hide-required-asterisk
        class="uc-msgbox-form"
      >
        <el-form-item prop="oldPassword">
          <el-input
            v-model="passwordForm.oldPassword"
            type="password"
            maxlength="15"
            show-password
            placeholder="请输入原密码"
          ></el-input>
        </el-form-item>
        <el-form-item prop="newPassword">
          <el-input
            v-model="passwordForm.newPassword"
            type="password"
            maxlength="15"
            show-password
            placeholder="设置新密码（6-15 位）"
          ></el-input>
        </el-form-item>
        <el-form-item prop="confirmPassword">
          <el-input
            v-model="passwordForm.confirmPassword"
            type="password"
            maxlength="15"
            show-password
            placeholder="请再次输入新密码"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="passwordDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="savePassword">
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { updateUserInfoAPI, updatePasswordAPI, updatePreferencesAPI } from "@/api";

export default {
  data() {
    // 新密码与原密码不能相同
    const validateDiffFromOld = (rule, value, callback) => {
      if (value && value === this.passwordForm.oldPassword) {
        callback(new Error("新密码不能与原密码相同"));
      } else {
        callback();
      }
    };
    // 两次输入的新密码必须一致
    const validateConfirm = (rule, value, callback) => {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };

    return {
      activeTab: "setting",
      submitting: false,

      // 偏好开关的本地值：接口失败时可回滚，避免界面与后端不一致
      showRecentVisitValue: true,

      nicknameDialogVisible: false,
      nicknameForm: { username: "" },
      nicknameRules: {
        username: [
          { required: true, message: "请输入昵称", trigger: "blur" },
          { min: 1, max: 8, message: "昵称长度为 1-8 个字符", trigger: "blur" },
        ],
      },

      passwordDialogVisible: false,
      passwordForm: { oldPassword: "", newPassword: "", confirmPassword: "" },
      passwordRules: {
        oldPassword: [{ required: true, message: "请输入原密码", trigger: "blur" }],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            pattern: /^\S{6,15}$/,
            message: "密码为 6-15 位非空字符",
            trigger: "blur",
          },
          { validator: validateDiffFromOld, trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          { validator: validateConfirm, trigger: "blur" },
        ],
      },
    };
  },

  computed: {
    userInfo() {
      return this.$store.state.userInfo || {};
    },
    // 头像占位文字：取昵称首个字符（Array.from 保证 emoji 等多字节字符不被截断）
    avatarText() {
      const name = this.userInfo.username || "";
      return name ? Array.from(name)[0] : "村";
    },
    // 注册时间：老数据该字段为 NULL，显示"未记录"
    formattedCreateTime() {
      const raw = this.userInfo.create_time;
      if (!raw) return "未记录";
      const date = new Date(raw);
      if (isNaN(date.getTime())) return "未记录";
      const pad = (n) => String(n).padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
      )}`;
    },
  },

  watch: {
    // 用户信息拉取完成后同步开关初值
    "userInfo.show_recent_visit": {
      immediate: true,
      handler(val) {
        this.showRecentVisitValue =
          val === undefined || val === null || val === "" ? true : Number(val) === 1;
      },
    },
  },

  created() {
    // 正常由路由守卫拉取；此处兜底，保证直接进入本页也能拿到数据
    if (!this.userInfo.email) {
      this.$store.dispatch("getUserInfoActions").catch(() => {});
    }
  },

  methods: {
    // 退出登录
    handleLogout() {
      this.$confirm("确定要退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("logout");
        })
        .catch(() => {});
    },

    // 打开修改昵称弹窗
    openNicknameDialog() {
      this.nicknameForm.username = this.userInfo.username || "";
      this.nicknameDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.nicknameForm) this.$refs.nicknameForm.clearValidate();
      });
    },

    // 保存昵称
    saveNickname() {
      this.$refs.nicknameForm.validate(async (valid) => {
        if (!valid) return;

        const newName = (this.nicknameForm.username || "").trim();
        if (newName === this.userInfo.username) {
          this.$message.info("昵称未发生变化");
          this.nicknameDialogVisible = false;
          return;
        }

        this.submitting = true;
        try {
          const { data: res } = await updateUserInfoAPI({ username: newName });
          if (res.status !== 0) {
            this.$message.error(res.message || "修改失败");
            return;
          }
          // 同步 vuex：userInfo 供本页展示，username 供侧边栏"某某某的站村"
          this.$store.commit("updateUsername", newName);
          this.$message.success("昵称修改成功");
          this.nicknameDialogVisible = false;
        } catch (error) {
          console.error("修改昵称失败:", error);
          this.$message.error("修改失败，请重试");
        } finally {
          this.submitting = false;
        }
      });
    },

    // 打开修改密码弹窗
    openPasswordDialog() {
      this.passwordForm = {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      };
      this.passwordDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.passwordForm) this.$refs.passwordForm.clearValidate();
      });
    },

    // 保存新密码（原密码由后端二次校验，前端只做格式与一致性校验）
    savePassword() {
      this.$refs.passwordForm.validate(async (valid) => {
        if (!valid) return;

        this.submitting = true;
        try {
          const { data: res } = await updatePasswordAPI({
            oldPassword: this.passwordForm.oldPassword,
            newPassword: this.passwordForm.newPassword,
          });
          if (res.status !== 0) {
            this.$message.error(res.message || "修改失败");
            return;
          }
          this.$message.success("密码修改成功");
          this.passwordDialogVisible = false;
          this.passwordForm = {
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
          };
        } catch (error) {
          console.error("修改密码失败:", error);
          this.$message.error("修改失败，请重试");
        } finally {
          this.submitting = false;
        }
      });
    },

    // 切换"显示已访问过的村"：先乐观更新界面，失败则回滚并提示
    async onShowRecentChange(val) {
      const target = val ? 1 : 0;
      const previous = this.showRecentVisitValue;
      this.showRecentVisitValue = !!val;

      try {
        const { data: res } = await updatePreferencesAPI({
          show_recent_visit: target,
        });
        if (res.status !== 0) {
          this.showRecentVisitValue = previous;
          this.$message.error(res.message || "保存失败");
          return;
        }
        this.$store.commit("updateUserPartial", { show_recent_visit: target });
        this.$message.success(target === 1 ? "已开启显示" : "已关闭显示");
      } catch (error) {
        console.error("保存偏好设置失败:", error);
        this.showRecentVisitValue = previous;
        this.$message.error("保存失败，请重试");
      }
    },
  },
};
</script>

<style scoped>
.usercenter {
  /* 宽度跟随内容区唯一基准 .main-content(968px)，不再单独设 1000px，
     否则用户中心会比首页宽出 32px，两个页面切换时宽度会跳动 */
  width: 100%;
  /* 顶部留白：叠加 el-main 的 24px padding 后，标题距页面顶部约 88px */
  padding-top: 64px;
  padding-bottom: 40px;
}

/* ==================== 顶部标题区 ==================== */
.uc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 28px;
}

.uc-title {
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  color: #1d1d1f;
  line-height: 40px;
}

/* ==================== Tab ==================== */
.uc-tabs ::v-deep .el-tabs__header {
  margin: 0 0 32px;
}

.uc-tabs ::v-deep .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #e7e7e7;
}

.uc-tabs ::v-deep .el-tabs__item {
  height: 40px;
  line-height: 40px;
  /* 用 padding + margin 组合：item 宽度等于文字宽度，激活下划线才能与文字等宽并对齐左缘 */
  padding: 0;
  margin-right: 32px;
  font-size: 14px;
  color: #909399;
}

.uc-tabs ::v-deep .el-tabs__item.is-active {
  color: #ff4d90;
}

/* 禁用态（导入导出）：置灰且不可点击 */
.uc-tabs ::v-deep .el-tabs__item.is-disabled {
  color: #c8c9cc;
  cursor: not-allowed;
}

.uc-tabs ::v-deep .el-tabs__active-bar {
  height: 2px;
  background-color: #ff4d90;
}

/* ==================== 区块 ==================== */
.uc-section {
  margin-bottom: 32px;
}

.uc-section-title {
  margin-bottom: 12px;
  font-size: 13px;
  color: #909399;
  line-height: 20px;
}

/* ==================== 账号信息 ==================== */
.uc-account {
  display: flex;
  align-items: center;
}

.uc-avatar {
  width: 52px;
  height: 52px;
  margin-right: 16px;
  border-radius: 50%;
  background-color: #fde9f1;
  color: #ff4d90;
  font-size: 20px;
  line-height: 52px;
  text-align: center;
  flex-shrink: 0;
}

.uc-account-info {
  min-width: 0;
}

.uc-nickname {
  font-size: 16px;
  font-weight: 600;
  color: #1d1d1f;
  line-height: 24px;
}

.uc-email {
  font-size: 13px;
  color: #909399;
  line-height: 20px;
}

/* ==================== 设置行 ==================== */
.uc-row {
  display: flex;
  align-items: center;
  min-height: 56px;
  border-bottom: 1px solid #f0f0f0;
}

.uc-row--last {
  border-bottom: none;
}

/* 标签列固定 105px，与设计稿中"值"的起始位置对齐 */
.uc-row-label {
  width: 105px;
  flex-shrink: 0;
  font-size: 14px;
  color: #909399;
}

.uc-row-value {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  color: #1d1d1f;
  word-break: break-all;
}

.uc-row-action {
  flex-shrink: 0;
  margin-left: 16px;
}

/* ==================== 偏好设置 ==================== */
.uc-pref-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 56px;
}

.uc-pref-label {
  font-size: 14px;
  color: #1d1d1f;
}

/* ==================== 注销账号 ==================== */
.uc-danger {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.uc-danger-text {
  font-size: 13px;
  color: #a8a8a8;
  line-height: 20px;
}

/* ==================== 通用按钮 ==================== */
.uc-plain-btn {
  height: 36px;
  padding: 0 18px;
  font-size: 14px;
  color: #1d1d1f;
  background-color: #ffffff;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
}

.uc-plain-btn:hover,
.uc-plain-btn:focus {
  color: #1d1d1f;
  background-color: #fafafa;
  border-color: #c8c9cc;
}

.uc-plain-btn.is-disabled,
.uc-plain-btn.is-disabled:hover {
  color: #c0c4cc;
  background-color: #ffffff;
  border-color: #ebeef5;
}

/* 禁用元素外层包一层，保证 tooltip 可触发 */
.uc-disabled-wrap {
  display: inline-block;
  line-height: 1;
}

/* 弹窗主按钮直接复用 Element 主题的 el-button--primary（该主题已设为 #ff4d90），
   与退出登录确认框的"确定"按钮完全一致，不再单独自定义 */

/* ============ 修改昵称 / 修改密码弹窗 ============
   参数：420px 宽、上下左右居中、1px #ebeef5 描边、0 2px 12px 浅阴影、
   18px 标题、14px 正文、底部按钮右对齐（取消在左 / 保存在右，主按钮随主题为 #ff4d90）

   2026-09-24 改版：表单排法**对齐登录页** —— 去掉左侧 label 与红色必填星号，
   改用 placeholder 引导；字段行距 22→24px，body/footer 留白放大到 20px。
   （原先是照 Element MessageBox 的紧凑留白，显得拥挤；现在登录页的
     「重置密码」弹窗 .fp-msgbox 与本文件用同一套参数，改一处记得同步另一处）

   注意：global.css 里有一条 `.el-dialog:not(.uc-msgbox){ margin:0 auto 0 240px !important; height:100% }`
   是给全屏面板型弹窗用的，此处已被 :not() 排除；
   这里的 height:auto 用于覆盖 Element 默认与全局的满高设定 */
::v-deep .uc-msgbox {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  height: auto;
  /* 内容过高时自身滚动，避免绝对居中导致顶部被裁切 */
  max-height: calc(100vh - 80px);
  overflow-y: auto;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

::v-deep .uc-msgbox .el-dialog__header {
  padding: 18px 20px 4px;
}

::v-deep .uc-msgbox .el-dialog__title {
  font-size: 18px;
  line-height: 1;
  color: #303133;
}

::v-deep .uc-msgbox .el-dialog__headerbtn {
  top: 15px;
  right: 15px;
}

::v-deep .uc-msgbox .el-dialog__headerbtn:hover .el-dialog__close,
::v-deep .uc-msgbox .el-dialog__headerbtn:focus .el-dialog__close {
  color: #ff4d90;
}

::v-deep .uc-msgbox .el-dialog__body {
  padding: 16px 20px 0;
  color: #606266;
  font-size: 14px;
}

::v-deep .uc-msgbox .el-dialog__footer {
  padding: 14px 20px 18px;
  text-align: right;
}

/* 表单排法对齐登录页：无 label（placeholder 引导）、24px 行距 */
.uc-msgbox-form ::v-deep .el-form-item {
  margin-bottom: 24px;
}

.uc-msgbox-form ::v-deep .el-form-item:last-child {
  margin-bottom: 0;
}
</style>
